<div class="demooz_toggle"      
    [class.label_end]="this.labelPlacement === 'end'"
    [class.no_margin]="this.noMargin"
    >
    <ion-toggle [formControlName]="this.formName" [labelPlacement]="this.labelPlacement" [enableOnOffLabels]="this.enableOnOffLabels" mode="ios">
        {{this.labelToggle}}
    </ion-toggle>
</div>